import { render, staticRenderFns } from "./account-info-card.component.vue?vue&type=template&id=f96412a8"
import script from "./account-info-card.component.vue?vue&type=script&lang=js"
export * from "./account-info-card.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports